import lastIndexOf from 'lodash/lastIndexOf'

if (!Array.prototype.lastIndexOf) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.lastIndexOf = (searchElement, fromIndex) => {
    return lastIndexOf(this, searchElement, fromIndex)
  }
}
export default lastIndexOf
